import { createSelector } from "reselect";
import { createFirstPageAllFacilitiesQuerySelector } from "../create_first_page_all_facilities_query_selector";

export function createFirstPageAllFacilitiesContextSelector() {
  return createSelector(
    createFirstPageAllFacilitiesQuerySelector(),
    query => query
  );
}
